import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'evc-loading-spinner',
  templateUrl: './spinner.component.svg',
  styleUrl: './spinner.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {}
